export const TOOLBAR_OBSERVER_CONFIG: MutationObserverInit = {
  attributeFilter: ['class'],
  attributes: true,
  childList: true,
  subtree: true,
};
